<template>
  <div id="slate-int-calculator-methodology">
    <back-button v-on:backButtonClick="goBack" />
    <div class="heading">Methodology</div>
    <div class="methodology"><slot></slot></div>
  </div>
</template>

<script>
import BackButton from '../../.././slate-int-back-button/src/BackButton'

export default {
  name: 'calculatorMethodology',
  methods: {
    goBack () {
      this.$emit('goBack')
    }
  },
  components: {
    'back-button': BackButton
  }
}
</script>

<style scoped>
#slate-int-calculator-methodology {
  text-align: left;
}
.heading {
  text-align: center;
  font-family: sl-TitlingGothicFBCondensed, helvetica, sans-serif;
  margin-top: 0;
  margin-bottom: 0.5em;
  font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// CalculatorMethodology.vue?4f11df49